import { QuestionPlanShortStayParams as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/short-stay-params";

import { useDayTripPlanShortStayParams } from "./hooks";

export const QuestionDayTripPlanShortStayParams = () => {
	const { shortStayParams, onSetShortStayParams } = useDayTripPlanShortStayParams();

	return <Question shortStayParams={shortStayParams} onSetShortStayParams={onSetShortStayParams} />;
};

QuestionDayTripPlanShortStayParams.displayName = "QuestionDayTripPlanShortStayParams";
